import React from 'react';
import classnames from 'classnames';
import { buildBemClassName } from '../modules/util';
import { useTranslation } from 'react-i18next';

export interface RepeatControlProps {
  repeat: number;
  options: number[];
  className?: string;
  disabled?: boolean;
  onRepeatChange: (repeat: number) => void;
}

const buildClassName = buildBemClassName('c-rr-repeat-control');

export const formatRepeat = (repeat: number): string =>
  isFinite(repeat) ? `${repeat}×` : '∞';

const RepeatControl = ({
  repeat,
  options,
  className = '',
  disabled = false,
  onRepeatChange,
}: RepeatControlProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    const currentIndex = options.indexOf(repeat);
    const nextIndex = (currentIndex + 1) % options.length;
    onRepeatChange(options[nextIndex]);
  };

  return (
    <button
      type="button"
      className={classnames(
        className,
        'c-rr-button',
        'c-rr-button--dark',
        buildClassName()()
      )}
      onClick={handleClick}
      disabled={disabled}
      title={t('repeat')}
      aria-label={`${t('repeat')}: ${formatRepeat(repeat)}`}
    >
      {t('repeat')}: {formatRepeat(repeat)}
    </button>
  );
};

export default RepeatControl;
